module.exports = __webpack_public_path__ + "img/CustomerEngagement.75bdfcad.svg";